import { z } from 'zod';

export const ScheduleItemTypeSchema = z.enum(['UNIT', 'CONVERSATION', 'ASSESSMENT']);

export type ScheduleItemTypeType = `${z.infer<typeof ScheduleItemTypeSchema>}`;

export const AdminCourseScheduleItemSchema = z.object({
  Semester: z
    .string({
      error: (issue) =>
        issue.input === undefined ? 'Semester is required' : 'Semester must be a string',
    })
    .min(1, { error: 'Semester is required' }),
  Week: z
    .string({
      error: (issue) => (issue.input === undefined ? 'Week is required' : 'Week must be a string'),
    })
    .min(1, { error: 'Week is required' }),
  'Unit Code': z.string().min(1, { error: 'Unit Code is required' }),
  Title: z.string().min(1, { error: 'Title is required' }),
  id: z.string().min(1, { error: 'ID is required' }),
  type: ScheduleItemTypeSchema,
  unitId: z.string().min(1, { error: 'Unit ID is required' }),
});

export type AdminCourseScheduleItem = {
  Semester: string;
  Week: string;
  'Unit Code': string;
  Title: string;
  id: string;
  type: ScheduleItemTypeType;
  unitId: string;
};

export const courseHasSemesterTwo = (schedule: AdminCourseScheduleItem[]) => {
  return schedule.some((item) => item.Semester === '2');
};

export type AdminCourseScheduleItemType = z.infer<typeof AdminCourseScheduleItemSchema>;
